import { createContext, useState } from "react"
import { StudentLessonResult } from "types"

export const StudentContext = createContext(null)

export const StudentContextProvider = ({ children, initialStudent, classId }) => {
    const [lessonResults, setlessonResults] = useState<StudentLessonResult[]>([])

    return(
        <StudentContext.Provider value={{
            studentId: initialStudent.userId,
            classId
        }}>
            { children }
        </StudentContext.Provider>
    )
}